import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const Contact: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <div className="pt-20 md:pt-24">
      <section
        ref={ref}
        className="py-20 md:py-28 bg-penn-blue min-h-screen"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Join Our Lab
            </h1>
            <div className="w-24 h-1 bg-penn-red mx-auto mb-8"></div>
            <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Interested in joining our team? We welcome inquiries from prospective
              postdocs, graduate students, and undergraduate researchers.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Get in Touch */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-white rounded-lg p-8 shadow-lg flex flex-col"
            >
              <h2 className="text-2xl font-bold text-penn-blue mb-6">
                Get in Touch
              </h2>

              <div className="space-y-6 flex-grow">
                <div>
                  <p className="font-semibold text-neutral-dark mb-2 text-lg">Location</p>
                  <p className="text-neutral-dark leading-relaxed">
                    University of Pennsylvania
                    <br />
                    3620 Hamilton Walk
                    <br />
                    27 John Morgan
                    <br />
                    Philadelphia, PA 19104
                  </p>
                </div>

                <div>
                  <p className="font-semibold text-neutral-dark mb-2 text-lg">Email</p>
                  <a
                    href="mailto:jmcichon@gmail.com"
                    className="text-penn-red hover:text-penn-blue transition-colors text-lg break-all"
                  >
                    jmcichon@gmail.com
                  </a>
                </div>

                <div className="pt-4">
                  <p className="font-semibold text-neutral-dark mb-2 text-lg">Links</p>
                  <div className="space-y-2">
                    <a
                      href="https://www.med.upenn.edu/apps/faculty/index.php/g275/p9009746"
                      className="block text-penn-red hover:text-penn-blue transition-colors"
                    >
                      Joe's UPenn Profile
                    </a>
                    <a
                      href="https://pubmed.ncbi.nlm.nih.gov/?term=(Cichon%20J%20AND%20Pennsylvania)%20OR%20(Cichon%20J%20AND%20New%20York)&sort=date"
                      className="block text-penn-red hover:text-penn-blue transition-colors"
                    >
                      Publications
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Join Our Team */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="bg-white rounded-lg p-8 shadow-lg"
            >
              <h2 className="text-2xl font-bold text-penn-blue mb-6">
                Join Our Team
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-bold text-penn-red mb-2">
                    Postdoctoral Positions
                  </h3>
                  <p className="text-neutral-dark text-sm leading-relaxed">
                    The Cichon lab welcomes residents and postdoctoral fellows, rotation students from Penn graduate programs, medical students, and undergraduates.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-penn-red mb-2">Graduate Students</h3>
                  <p className="text-neutral-dark text-sm leading-relaxed">
                    Please reach out to Dr. Cichon and mention your interest in the Cichon Lab in your message.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-penn-red mb-2">
                    Undergraduate Researchers
                  </h3>
                  <p className="text-neutral-dark text-sm leading-relaxed">
                    We also encourage Penn undergraduates interested in research experience to
                    reach out.
                  </p>
                </div>

                <a
                  href="mailto:jmcichon@gmail.com"
                  className="inline-block bg-penn-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-penn-blue transition-colors"
                >
                  Contact Us to Join
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;


